import React from "react";
import MediaQueryDetalles from "./MediaQueryDetalles";

const Page = () => (
    <MediaQueryDetalles></MediaQueryDetalles>
);

export default Page;